import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import FooterSection from '../home/components/FooterSection';

export default function MentionsLegalesPage() {
  useEffect(() => {
    document.title = 'Mentions Légales – UzunDigital';
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

    let metaDesc = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    metaDesc.setAttribute('content', 'Mentions légales de UzunDigital – SIRET 998 939 037 00011. Informations légales, éditeur du site, hébergement et politique de confidentialité.');

    let robotsMeta = document.querySelector('meta[name="robots"]') as HTMLMetaElement | null;
    if (!robotsMeta) {
      robotsMeta = document.createElement('meta');
      robotsMeta.setAttribute('name', 'robots');
      document.head.appendChild(robotsMeta);
    }
    robotsMeta.setAttribute('content', 'noindex, follow');

    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (canonical) {
      canonical.href = `${siteUrl}/mentions-legales`;
    } else {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      canonical.href = `${siteUrl}/mentions-legales`;
      document.head.appendChild(canonical);
    }

    return () => {
      const robots = document.querySelector('meta[name="robots"]');
      if (robots) robots.setAttribute('content', 'index, follow');
    };
  }, []);

  const sections = [
    {
      id: 'editeur',
      icon: 'ri-building-line',
      title: 'Éditeur du site',
      content: [
        { label: 'Dénomination', value: 'UzunDigital' },
        { label: 'Forme juridique', value: 'Micro-entreprise' },
        { label: 'SIRET', value: '998 939 037 00011' },
        { label: 'Adresse e-mail', value: 'uzundigital71@gmail.com', href: 'mailto:uzundigital71@gmail.com' },
        { label: 'Téléphone', value: '06 51 87 24 35', href: 'tel:+33651872435' },
      ],
    },
    {
      id: 'directeur',
      icon: 'ri-user-star-line',
      title: 'Directeur de la publication',
      content: [
        { label: 'Responsable', value: 'UzunDigital' },
        { label: 'Contact', value: 'uzundigital71@gmail.com', href: 'mailto:uzundigital71@gmail.com' },
      ],
    },
    {
      id: 'hebergement',
      icon: 'ri-server-line',
      title: 'Hébergement',
      content: [
        { label: 'Type', value: 'Hébergement cloud sécurisé' },
        { label: 'Localisation', value: 'Union Européenne' },
      ],
    },
    {
      id: 'propriete',
      icon: 'ri-copyright-line',
      title: 'Propriété intellectuelle',
      text: 'L\'ensemble des contenus présents sur ce site (textes, images, graphismes, logo, icônes) est la propriété exclusive de UzunDigital, sauf mention contraire. Toute reproduction, distribution, modification ou utilisation sans autorisation préalable et écrite de UzunDigital est strictement interdite.',
    },
    {
      id: 'donnees',
      icon: 'ri-shield-user-line',
      title: 'Protection des données personnelles',
      text: 'Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés du 6 janvier 1978, vous disposez d\'un droit d\'accès, de rectification, d\'opposition et de suppression des données vous concernant. Pour exercer ces droits, contactez-nous à : uzundigital71@gmail.com. Les données collectées via les formulaires de ce site sont uniquement utilisées dans le cadre de la gestion de vos demandes et ne sont pas cédées à des tiers.',
    },
    {
      id: 'cookies',
      icon: 'ri-cookie-line',
      title: 'Cookies',
      text: 'Ce site utilise des cookies fonctionnels et analytiques (Google Analytics, Google Tag Manager) afin d\'améliorer votre expérience de navigation et analyser l\'audience du site. Vous pouvez configurer votre navigateur pour refuser les cookies ou être averti lorsque des cookies sont envoyés.',
    },
    {
      id: 'responsabilite',
      icon: 'ri-information-line',
      title: 'Limitation de responsabilité',
      text: 'UzunDigital s\'efforce d\'assurer l\'exactitude et la mise à jour des informations diffusées sur ce site. Toutefois, UzunDigital ne peut garantir l\'exactitude, la complétude et l\'actualité des informations diffusées. UzunDigital ne peut être tenu responsable de tout dommage direct ou indirect résultant de l\'utilisation de ce site.',
    },
  ];

  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <Navbar />

      {/* Hero */}
      <section className="pt-28 sm:pt-36 pb-12 sm:pb-16 px-4 sm:px-6 bg-slate-50 border-b border-slate-100">
        <div className="max-w-3xl mx-auto">
          <div className="flex items-center gap-2 text-xs text-slate-400 font-semibold mb-6">
            <Link to="/" className="hover:text-emerald-500 transition-colors cursor-pointer">Accueil</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-slate-600">Mentions légales</span>
          </div>

          <div className="flex items-center gap-4 mb-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-2xl bg-emerald-100 flex-shrink-0">
              <i className="ri-file-text-line text-emerald-600 text-2xl"></i>
            </div>
            <h1 className="text-2xl sm:text-4xl font-black text-slate-900">Mentions Légales</h1>
          </div>
          <p className="text-slate-500 text-sm sm:text-base">
            Conformément aux articles 6-III et 19 de la Loi n° 2004-575 du 21 juin 2004 pour la confiance dans l&apos;économie numérique (LCEN), les présentes mentions légales sont portées à la connaissance des utilisateurs du site.
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 sm:py-16 px-4 sm:px-6">
        <div className="max-w-3xl mx-auto space-y-6 sm:space-y-8">
          {sections.map((section) => (
            <div key={section.id} className="bg-white border border-slate-100 rounded-2xl overflow-hidden">
              {/* Section header */}
              <div className="flex items-center gap-3 px-6 py-4 bg-slate-50 border-b border-slate-100">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-emerald-100 flex-shrink-0">
                  <i className={`${section.icon} text-emerald-600 text-base`}></i>
                </div>
                <h2 className="text-sm sm:text-base font-black text-slate-900">{section.title}</h2>
              </div>

              <div className="px-6 py-5">
                {section.content && (
                  <dl className="space-y-3">
                    {section.content.map((item) => (
                      <div key={item.label} className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-0">
                        <dt className="text-xs font-bold text-slate-500 uppercase tracking-wide sm:w-40 flex-shrink-0">{item.label}</dt>
                        <dd className="text-sm text-slate-800 font-semibold">
                          {item.href ? (
                            <a
                              href={item.href}
                              className="hover:text-emerald-600 transition-colors cursor-pointer"
                              {...(item.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                            >
                              {item.value}
                            </a>
                          ) : (
                            item.value
                          )}
                        </dd>
                      </div>
                    ))}
                  </dl>
                )}

                {section.text && (
                  <p className="text-sm text-slate-600 leading-relaxed">{section.text}</p>
                )}
              </div>
            </div>
          ))}

          {/* Last updated */}
          <div className="text-center pt-4">
            <p className="text-xs text-slate-400">
              Dernière mise à jour : mars 2026
            </p>
          </div>
        </div>
      </section>

      <FooterSection />
    </div>
  );
}
